export const addSpace = list => {
    if (!list) {
        return ''; // Return empty string or handle null case as needed
    }
    const edited = list.replace(/,/g, ', ');
    return edited;
}
